import request from '../util/http'

export default class APIS {

    
    static getBtnStatus = () => request.get(`home/btn_status`);

    static collectEmails = params => request.post(`home/collect_emails`, params);

    static getSubscribe = () => request.get(`home/get_subscribe`);
   
    static getDialogContent=params=> request.get(`/home/dialog_content_info`,{params:params});
   
    static getCarousel = () => request.get(`home/index`);
  }
  